import { render, staticRenderFns } from "./fileGrid.vue?vue&type=template&id=4a33c6d2&scoped=true"
import script from "./fileGrid.vue?vue&type=script&lang=js"
export * from "./fileGrid.vue?vue&type=script&lang=js"
import style0 from "./fileGrid.vue?vue&type=style&index=0&id=4a33c6d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33c6d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a33c6d2')) {
      api.createRecord('4a33c6d2', component.options)
    } else {
      api.reload('4a33c6d2', component.options)
    }
    module.hot.accept("./fileGrid.vue?vue&type=template&id=4a33c6d2&scoped=true", function () {
      api.rerender('4a33c6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cloudSpace/components/fileGrid.vue"
export default component.exports